<ng-container *ngFor="let item of items; trackBy: trackItem">
  <ng-template
    [ngIf]="item.route"
    [ngIfThen]="withRouteTmpl"
    [ngIfElse]="withoutRouteTmpl"
  ></ng-template>

  <ng-template #withRouteTmpl>
    <button
      mat-menu-item
      *ngIf="!item.hidden(context)"
      [disabled]="item.disabled(context)"
      [routerLink]="item.route?.link"
      [replaceUrl]="item.route?.replaceUrl"
      [state]="item.route?.state"
      [skipLocationChange]="item.route?.skipLocationChange"
      [queryParams]="item.route?.queryParams"
      [queryParamsHandling]="item.route?.queryParamsHandling"
      [fragment]="item.route?.fragment"
      [preserveFragment]="item.route?.preserveFragment"
      (click)="item.click(context)"
    >
      <ng-template [ngTemplateOutlet]="iconTmpl"></ng-template>
    </button>
  </ng-template>

  <ng-template #withoutRouteTmpl>
    <button
      mat-menu-item
      *ngIf="!item.hidden(context)"
      [disabled]="item.disabled(context)"
      (click)="item.click(context)"
    >
      <ng-template [ngTemplateOutlet]="iconTmpl"></ng-template>
    </button>
  </ng-template>

  <ng-template #iconTmpl>
    <ng-container *ngIf="item.icon?.template; else contentTmpl">
      <span [innerHTML]="item.icon.template" [class]="item.icon.class"> </span>
      {{ item.label | t }}
    </ng-container>
    <ng-template #contentTmpl>
      <sn-icon
        *ngIf="item.icon as icon"
        [icon]="icon.icon"
        [class]="icon.class"
        [fontSet]="icon.fontSet"
        [fontIcon]="icon.fontIcon"
        [fontIconUnicode]="icon.fontIconUnicode"
        [svgIcon]="icon.svgIcon"
        [snBadge]="item.badge?.value"
        [snSmartBadge]="item.badge?.name"
        [snBadgeColor]="item.badge?.color"
        [snBadgePositionX]="item.badge?.positionX"
        [snBadgePositionY]="item.badge?.positionY"
      >
      </sn-icon>
      {{ item.label | t }}
    </ng-template>
  </ng-template>

  <ng-content></ng-content>
</ng-container>
